import { ApiPost } from './Common.ts'
import { GetWebConnectorUrl } from '../stores/SettingsStore.ts'

export interface ConsultantBookmarkAddRequest {
  BeeNumberBookmark: number
  Name: string
  ReportId: string
}

export interface ConsultantBookmarkAddResponse {
  ResponseStatus?: unknown
}

export interface ConsultantBookmarkRemoveRequest {
  BeeNumberBookmark: number
  ReportId: string
}

export interface ConsultantBookmarkRemoveResponse {
  ResponseStatus?: unknown
}

export interface ConsultantBookmarkCheckRequest {
  BeeNumberBookmark: number
  ReportId: string
}

export interface ConsultantBookmarkCheckResponse {
  responseStatus?: unknown
  isBookmarked: boolean
}

export interface ConsultantBookmarkGetListRequest {
  ReportId: string
}

export interface IConsultantBookmark {
  sfaTeamDetailsBookmarkGuid: number
  beeNumberBookmark: number
  name: string
  reportId: string
  displayOrder: number
}

export interface ConsultantBookmarkGetListResponse {
  responseStatus?: unknown
  items: IConsultantBookmark[]
}

export async function ConsultantBookmarkAdd(
  request: ConsultantBookmarkAddRequest,
): Promise<ConsultantBookmarkAddResponse> {
  const url = await GetWebConnectorUrl('ConsultantBookmarkAdd')
  return ApiPost(url, request)
}

export async function ConsultantBookmarkRemove(
  request: ConsultantBookmarkRemoveRequest,
): Promise<ConsultantBookmarkRemoveResponse> {
  const url = await GetWebConnectorUrl('ConsultantBookmarkRemove')
  return ApiPost(url, request)
}

export async function ConsultantBookmarkCheck(
  request: ConsultantBookmarkCheckRequest,
): Promise<ConsultantBookmarkCheckResponse> {
  const url = await GetWebConnectorUrl('ConsultantBookmarkCheck')
  return ApiPost(url, request)
}

export async function ConsultantBookmarkGetList(
  request: ConsultantBookmarkGetListRequest,
): Promise<ConsultantBookmarkGetListResponse> {
  const url = await GetWebConnectorUrl('ConsultantBookmarkGetList')
  return ApiPost(url, request)
}
